import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { NoneSelectedMessage } from "../../common/NoneSelected";
import labelIcon from "../../../images/label.svg";
import mspIcon from "../../../images/user-fields-tracking-key-figure.svg";
import carIcon from "../../../images/car.svg";
import copyIcon from "../../../images/copy.svg";

function TicketInfo() {
  const { t } = useTranslation();
  const currentCase = useSelector((state) => state.currentCase?.currentCase?.case);
  const contract = useSelector((state) => state.contract?.contract);
  const caseStates = useSelector((state) => state.caseStates?.caseStates);

  const [copiedKey, setCopiedKey] = useState(null);

  const caseId = currentCase?.caseId != null && currentCase?.caseId !== 0 ? String(currentCase.caseId) : "";
  const mspId = currentCase?.mspid || currentCase?.MSPID || "";
  const plate = currentCase?.mspPlate || currentCase?.plate || contract?.plate || "";
  const status =
    caseStates?.find((s) => s.stateId === currentCase?.stateId)?.description ||
    currentCase?.state ||
    currentCase?.caseState ||
    "";

  const fields = [
    {
      key: "caseId",
      label: t("TicketInfo.CaseId"),
      value: caseId,
      icon: labelIcon,
    },
    {
      key: "mspId",
      label: t("TicketInfo.MspId"),
      value: mspId,
      icon: mspIcon,
    },
    {
      key: "plate",
      label: t("TicketInfo.Plate"),
      value: plate,
      icon: carIcon,
    },
    {
      key: "status",
      label: t("TicketInfo.Status"),
      value: status,
      icon: mspIcon,
    },
  ];

  const handleCopy = (fieldKey, value) => {
    if (!value || value === "-") {
      return;
    }

    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(value);
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = value;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }

    setCopiedKey(fieldKey);
    setTimeout(() => {
      setCopiedKey(null);
    }, 2000);
  };

  if (!caseId) {
    return <NoneSelectedMessage message={t("TicketInfo.NoSelected")} />;
  }

  return (
    <div style={{ marginTop: "1rem", display: "flex", flexDirection: "column", rowGap: "0.75rem" }}>
      {fields.map((field) => (
        <div
          key={field.key}
          style={{
            display: "flex",
            flexDirection: "column",
            rowGap: "0.375rem",
            padding: "0.125rem 0",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <img
              src={field.icon}
              alt=""
              style={{ width: "1.125rem", height: "1.125rem", flexShrink: 0 }}
            />
            <span style={{ fontWeight: 700, fontSize: "0.8125rem", color: "#333", whiteSpace: "nowrap" }}>
              {field.label}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "0.375rem", minWidth: 0 }}>
            <span
              style={{
                fontSize: "0.8125rem",
                color: "#262626",
                backgroundColor: "#E0E2E5",
                borderRadius: "12px",
                padding: "2px 8px",
                display: "inline-block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "calc(100% - 32px)",
              }}
              title={field.value || "-"}
            >
              {field.value || "-"}
            </span>
            <Tooltip title={copiedKey === field.key ? t("TicketInfo.Copied") : t("TicketInfo.Copy")}>
              <span>
                <IconButton
                  size="small"
                  disabled={!field.value}
                  onClick={() => handleCopy(field.key, field.value)}
                  style={{ padding: "4px", flexShrink: 0 }}
                  aria-label={`${t("TicketInfo.Copy")} ${field.label}`}
                >
                  <img src={copyIcon} alt="" style={{ width: "1.125rem", height: "1.125rem" }} />
                </IconButton>
              </span>
            </Tooltip>
          </div>
        </div>
      ))}
    </div>
  );
}

export { TicketInfo };
